function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires+ ";path=/";
}
function getMerchCookie(name) {
  const match = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
  return (match ? match.pop() : '') || '';
}

function eraseCookie(name) {   
  document.cookie = name+'=; Max-Age=-99999999;';  
}

window['friendbuy'] = window['friendbuy'] || [];
window['friendbuy'].push(['site', 'site-5c846fb3-host']);
window['friendbuy'].push(['track', 'customer',
{
  id: '{{ customer.id }}',
  email: '{{ customer.email }}',
  first_name: '{{ customer.first_name }}',
  last_name: '{{ customer.last_name }}'
}
]);
(function (f, r, n, d, b, y) {
b = f.createElement(r), y = f.getElementsByTagName(r)[0];b.async = 1;b.src = n;y.parentNode.insertBefore(b, y);
})(document, 'script', '//djnf6e5yyirys.cloudfront.net/js/friendbuy.min.js');

/*<!-- Pinterest base code -->*/
!function(e){if(!window.pintrk){window.pintrk=function()
{window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var
n=window.pintrk;n.queue=[],n.version="3.0";var
t=document.createElement("script");t.async=!0,t.src=e;var
r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r)}}
("https://s.pinimg.com/ct/core.js");

pintrk('load','2615791285943', { em: '{{ customer.email }}', });
pintrk('page');

var isWindowLoadedWithCookie = false;
var cookieConsObj = {
  "palette": {
    "popup": {
      "background": "#4B4B55"
    },
    "button": {
      "background": "#ffffff",
      "text": "#FF671D"
    }
  },
  "theme": "classic",
  "content": {
  header: 'Cookies used on the website!',
  message: 'We use cookies to give you the best experience on our website. By continuing to browse the site, you are agreeing to our use of cookies. More information can be found in our <a href="/pages/privacy-policy">Privacy Policy</a> and <a href="/pages/terms-of-service">Terms of Service</a>.',
  dismiss: '',
  showLink: 'false',
  }
};
window.addEventListener("load", function(){
  isWindowLoadedWithCookie = true;
});
